import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../contrib/ui';

export const ScorerPaperStyled = styled(Paper)`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: ${px(10)};
  margin-bottom: ${px(15)};

  .scorer-actions {
    button {
      padding-right: 0;
      span {
        svg {
          font-size: ${px(45)};
          margin-left: 0;
        }
      }
    }
    .css-actions {
      button {
        span {
          color: white;
        }
      }
    }
  }

  .scorer-actions {
    margin-left: auto;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .score-stats {
      margin-right: 0;
    }

    .moneyball-indicator {
      padding-left: ${px(5)};
      min-width: ${px(25)};
      width: ${px(25)};
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      img {
        width: ${px(25)};
        height: ${px(25)};
        margin-right: 0;
      }
    }
  }

  .select-scorer-button {
    height: var(--midButtonHeight);
    margin-left: auto;
    margin-right: 0;
    padding: 0;
    width: ${px(120)};

    .button__label.override {
      ${fontFamilySize('Heavy', 14)}
      top: 0;
    }
  }
`;
